import AgendamentoDetailContent from "./AgendamentoDetailContent";

export default function AgendamentoDetail() {
  return <AgendamentoDetailContent />;
}
